import { client } from '@api/client';

import { ICount } from '@interfaces/common/common';
import { INotification, IOffset } from '@interfaces/notifications/notifications';

import { URL } from './urls';

const {
	allNotifications,
	notificationsCount,
	readAllNotifications,
	removeAllNotifications,
} = URL;

export const getAllNotifications = ({ offset }: IOffset): Promise<INotification> =>
	client.get(`/${allNotifications}?limit=20&offset=${offset}`);

export const getNotificationsCount = (isUnreadOnly: boolean): Promise<ICount> =>
	client.get(`/${notificationsCount}?isUnreadOnly=${isUnreadOnly}`);

export const deleteNotification = (id: string): Promise<void> => client.delete(`/${allNotifications}/${id}`);

export const readNotifications = (): Promise<void> => client.post(`/${readAllNotifications}`, {});

export const deleteAllNotifications = (): Promise<void> => client.delete(`/${removeAllNotifications}`);
